<template>
  <div>
    <el-menu
      v-if="isPc"
      :default-active="activeIndex"
      class="el-menu-vertical-demo"
      background-color="#F4F4F4"
      text-color="#9D9C9D"
      active-text-color="#ffffff"
      router
      >
      <el-menu-item :index="index+''" :route="`${item.url}`" v-for="(item, index) in menuList " :key=item.name>
        <span slot="title">{{item.name}}</span>
      </el-menu-item>
    </el-menu>
    <el-menu
      v-else
      mode="horizontal"
      :default-active="activeIndex"
      class="m-left-nav"
      text-color="#333"
      active-text-color="#fff"
      router
      >
      <el-menu-item :index="index+''" :route="`${item.url}`" v-for="(item, index) in menuList " :key=item.name>
        <span slot="title">{{item.name}}</span>
      </el-menu-item>
    </el-menu>
  </div>
</template>

<script>
import {mapState} from 'vuex'

export default {
  data(){
    return {
      activeIndex:'0',
      menuList:[
        {
          name:'簡介',
          url:'/introduce'
        },
        {
          name:'章程',
          url:'/regulations'
        },
        {
          name:'功能委員會',
          url:'/committee'
        },
        // {
        //   name:'秘書處',
        //   url:'/secretariat'
        // },
        {
          name:'組織架構',
          url:'/organization'
        },
        {
          name:'聯誼會',
          url:'/fraternity'
        },
        {
          name:'加入協會',
          url:'/apply'
        }
      ]
    }
  },
  methods: {
    
  },
  computed:{
    ...mapState(["isPc"]),
  },
  watch:{
    // headerMenuList(val){
    //   // console.log(val)
    //   val.map((item,index) => {
    //     if(item.leafNavigate.length>0&&item.url=='/introduce'){
    //       this.menuList=item.leafNavigate
    //     }
    //     this.menuList.map((item,index) => {
    //       if (item.url==this.$route.path){
    //         this.activeIndex=index+''
    //       }
    //     })
    //     // if (item.url==this.$route.name){
    //     //   this.activeIndex=index+''
    //     // }
    //   })
    // },
    $route(to,from){
      // console.log('to=====',to);
      // this.headerMenuList.map((item,index) => {
      //   if (item.url==to.name){
      //     this.activePath=index+''
      //   }
      // })
      this.menuList.map((item,index) => {
        if (item.url==this.$route.path){
          this.activeIndex=index+''
        }
      })
    }
  },
  mounted(){
    // this.headerMenuList.map((item,index) => {
    //   if(item.leafNavigate.length>0&&item.url=='/introduce'){
    //     this.menuList=item.leafNavigate
    //   }
      
    //   // if (item.url==this.$route.name){
    //   //   this.activeIndex=index+''
    //   // }
    // })
    // console.log(this.$route)

    //更换路由菜单对应变化
    this.menuList.map((item,index) => {
      if (item.url==this.$route.path){
        this.activeIndex=index+''
      }
    })
  }
}
</script>

<style lang="less" scoped>
.el-menu-vertical-demo{
  width: 200px;
  .el-menu-item{
    font-size: 18px;
    text-align: center;
    padding: 0!important;
  }
  .el-menu-item.is-active{
    background: #4f4e95!important;
  }
  .el-menu-item:hover{
    background: #4f4e95!important;
    color: #fff!important;
    i{
      color: #fff!important;
    }
  }
}
.m-left-nav{
  padding: 0 20px;
  margin-top: 10px;
  .el-menu-item{
    height: auto;
    line-height: 38px;
    margin-bottom: 10px;
    margin-right: 10px;
    padding: 0 5px;
    border: 1px solid #eee!important;
  }
  
}
</style>
<style>
.m-left-nav .el-menu-item.is-active{
  border-bottom: 1px solid #eee!important;
  background: #4f4e95;
}
.m-left-nav .el-menu-item:not(.is-disabled):hover{
  background-color: #4f4e95!important;
}
</style>